import { useMantineTheme } from '@mantine/core';

export function useGlobalTheme() {
  const theme = useMantineTheme();
  return theme;
}
